import React, { useState } from 'react';
import { Controller } from 'react-hook-form-new';
import {
  Checkbox,
  Divider,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from '@nextiva/next-ui-components';
import { isValidUrl } from 'utils/validators';
import { UrlTextField } from '../Steps.styled';
import { useWizardContextV3 } from '../WizardContextV3/WizardContextV3';
import { FIELD_NAMES, PRIVACY_POLICY_FIELDS } from '../constants';
import { UploadComponent } from '../FileUpload';
import { FileTypesDialogSupportingDocuments } from '../FileTypesDialog';
import { Body2Typo, OverlineTypo, SubtitleTypo } from '../WizardV3.styled';

const dataTestId = 'PlatformAdminUI-PrivatePolicy';
export function PrivacyPolicy() {
  const {
    control,
    filesSupportDocs,
    formState: { errors },
    watch,
  } = useWizardContextV3();
  const termsAndConditionsLink = watch(
    PRIVACY_POLICY_FIELDS.TERMS_CONDITION_LINK,
  );
  const [typeModal, setTypeModal] = useState(false);

  return (
    <Stack width="920px">
      <Typography variant="subtitle2" color="#0B1029">
        Share <b> privacy policy </b> (mandatory) and{' '}
        <b> terms and conditions </b>
        (optional)
      </Typography>
      <Body2Typo mt={2} mb={6}>
        Privacy policy should be easily located on your website. The privacy
        Policy must be clear that end user&apos;s personal info will not be
        shared or sold to third parties for the purpose of marketing. If social
        media website is used, privacy policy/terms and conditions can be pinned
        post.
      </Body2Typo>
      <Typography variant="subtitle3" color="#0B1029" fontWeight={500}>
        Provide link
      </Typography>
      <Stack direction="row" mt={2} mb={2}>
        <Controller
          control={control}
          name={PRIVACY_POLICY_FIELDS.PRIVACY_POLICY_LINK}
          rules={{ required: true, maxLength: 255, validate: isValidUrl }}
          render={({ field: { onChange, onBlur, value } }) => (
            <UrlTextField
              id="private-policy-link"
              data-testid={`${dataTestId}-PrivatePolicyLink`}
              label={
                <OverlineTypo>
                  {FIELD_NAMES[PRIVACY_POLICY_FIELDS.PRIVACY_POLICY_LINK]} *
                </OverlineTypo>
              }
              helperText="Please provide link from your website within 255 characters"
              placeholder="Enter URL"
              error={!!errors.privacyPolicyLink}
              onChange={onChange}
              onBlur={onBlur}
              value={value || ''}
            />
          )}
        />
        <Controller
          control={control}
          name={PRIVACY_POLICY_FIELDS.TERMS_CONDITION_LINK}
          rules={{ maxLength: 255 }}
          render={({ field: { onChange, onBlur, value } }) => (
            <TextField
              id="terms-condition-link"
              data-testid={`${dataTestId}-termsAndConditionsLink`}
              sx={{ mr: '32px' }}
              label={
                <OverlineTypo>
                  {FIELD_NAMES[PRIVACY_POLICY_FIELDS.TERMS_CONDITION_LINK]}
                </OverlineTypo>
              }
              helperText="Please provide link from your website within 255 characters"
              placeholder="Enter URL"
              error={
                // adding isValidUrl to rules makes this Textfield required, but we want this to be optional
                !!errors.termsAndConditionsLink &&
                !isValidUrl(termsAndConditionsLink)
              }
              onChange={onChange}
              onBlur={onBlur}
              value={value || ''}
            />
          )}
        />
      </Stack>
      <OverlineTypo color="#55596B">Or upload documents</OverlineTypo>
      <UploadComponent
        onFileFormats={setTypeModal}
        uploadedFiles={filesSupportDocs}
        attachmentType="supportingDocument"
      />
      <FileTypesDialogSupportingDocuments
        open={typeModal}
        setOpen={setTypeModal}
      />
      <Divider sx={{ mt: '48px' }} />
      <SubtitleTypo mt={4} mb={2}>
        Please confirm your compliance with mandatory messaging restrictions *
      </SubtitleTypo>
      <FormControlLabel
        control={
          <Controller
            control={control}
            name={PRIVACY_POLICY_FIELDS.AFFILIATE_MARKETING}
            rules={{ required: true }}
            render={({ field: { onChange, onBlur, value } }) => (
              <Checkbox
                checked={!!value}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                data-testid={`${dataTestId}-AffiliateMarketing-Checkbox`}
              />
            )}
          />
        }
        label={
          <Body2Typo
            ml={1}
            sx={{
              fontWeight: 500,
              color: errors.isConfirmedNotForAffiliateMarketing
                ? 'error.dark'
                : '#55596B',
            }}
          >
            I confirm that business messaging will not be used for Affiliate
            Marketing.
          </Body2Typo>
        }
      />
    </Stack>
  );
}
